export const HIDE_SERVICE = ['/app/home', '/app/card-list', '/app/account'];

export const LAST_CALL_KEY = 'lastApiCallTime';

export const CARD_OFFLINE_BINS = [
  '441779',
  '464252',
  '493137',
  '534092',
  '475440',
  '400000',
  '527901',
  '526087',
  '528014',
  '404470',
  '478733',
  '223504',
  '223430',
  '223420',
  '223600',
  '246001',
  '246000',
  '235019',
  '238003',
  '556150',
  '55323105',
  '534786',
  '451946',
  '404038',
  '553437',
  '428836',
  '559666',
  '436797',
  '559292',
  '524897',
  '533428',
  '531087',
  '532208',
  '513123',
  '535607',
  '534204',
  '536097',
  '519075',
  '556150',
  '52489753',
  '52489763',
  '555244',
  '534204',
  '535067',
  '536097',
  '556766'
];

export const CARD_REDUCE_BINS = [
  '441779',
  '464252',
  '493137',
  '534092',
  '475440',
  '400000',
  '527901',
  '526087',
  '528014',
  '404470',
  '478733',
  '223504',
  '223430',
  '223420',
  '223600',
  '246001',
  '246000',
  '235019',
  '238003',
  '556150',
  '55323105',
  '534786',
  '451946',
  '404038',
  '553437',
  '428836',
  '559666',
  '436797',
  '559292',
  '524897',
  '533428',
  '531087',
  '532208',
  '525797',
  '513123',
  '535607',
  '534204',
  '536097',
  '519075',
  '539502',
  '556150',
  '52489753',
  '52489763',
  '555244',
  '534204',
  '535067',
  '536097',
  '556766'
];

export const NOT_SHOW_REUFND_FEE = ['404038', '428836', '55323105', '559666', '534786'];

// 不展示操作明细的卡段
export const CARD_NO_OPERATER = ['471880'];

export const QBIT_BINS = ['471880', '475440'];

export const SMS_BINS = ['400000', '464252', '404470', '478733', '493137'];

export const YS_BINS = ['400000', '464252', '404470', '478733', '493137', '482916'];

export const Cbtis_BINS = ['428813'];

export const pageSizeOptions = [10, 30, 50];

export const STATE = [
  {
    code: 'AL',
    value: 'Alabama'
  },
  {
    code: 'AK',
    value: 'Alaska'
  },
  {
    code: 'AR',
    value: 'Arkansas'
  },
  {
    code: 'AZ',
    value: 'Arizona'
  },
  {
    code: 'CA',
    value: 'California'
  },
  {
    code: 'CO',
    value: 'Colorado'
  },
  {
    code: 'CT',
    value: 'Connecticut'
  },
  {
    code: 'DE',
    value: 'Delaware'
  },
  {
    code: 'DC',
    value: 'Washington DC'
  },
  {
    code: 'FL',
    value: 'Florida'
  },
  {
    code: 'GA',
    value: 'Georgia'
  },
  {
    code: 'HI',
    value: 'Hawaii'
  },
  {
    code: 'IA',
    value: 'Iowa'
  },
  {
    code: 'ID',
    value: 'Idaho'
  },
  {
    code: 'IL',
    value: 'Illinois'
  },
  {
    code: 'IN',
    value: 'Indiana'
  },
  {
    code: 'KS',
    value: 'Kansas'
  },
  {
    code: 'KY',
    value: 'Kentucky'
  },
  {
    code: 'LA',
    value: 'Louisiana'
  },
  {
    code: 'ME',
    value: 'Maine'
  },
  {
    code: 'MD',
    value: 'Maryland'
  },
  {
    code: 'MA',
    value: 'Massachusetts'
  },
  {
    code: 'MI',
    value: 'Michigan'
  },
  {
    code: 'MN',
    value: 'Minnesota'
  },
  {
    code: 'MS',
    value: 'Mississippi'
  },
  {
    code: 'MO',
    value: 'Missouri'
  },
  {
    code: 'MT',
    value: 'Montana'
  },
  {
    code: 'NC',
    value: 'North Carolina'
  },
  {
    code: 'ND',
    value: 'North Dakota'
  },
  {
    code: 'NE',
    value: 'Nebraska'
  },
  {
    code: 'NH',
    value: 'New Hampshire'
  },
  {
    code: 'NJ',
    value: 'New Jersey'
  },
  {
    code: 'NM',
    value: 'New Mexico'
  },
  {
    code: 'NY',
    value: 'New York'
  },
  {
    code: 'NV',
    value: 'Nevada'
  },
  {
    code: 'OH',
    value: 'Ohio'
  },
  {
    code: 'OK',
    value: 'Oklahoma'
  },
  {
    code: 'OR',
    value: 'Oregon'
  },
  {
    code: 'PA',
    value: 'Pennsylvania'
  },
  {
    code: 'RI',
    value: 'Rhode Island'
  },
  {
    code: 'SD',
    value: 'South Dakota'
  },
  {
    code: 'SC',
    value: 'South Carolina'
  },
  {
    code: 'TN',
    value: 'Tennessee'
  },
  {
    code: 'TX',
    value: 'Texas'
  },
  {
    code: 'UT',
    value: 'Utah'
  },
  {
    code: 'VA',
    value: 'Virginia'
  },
  {
    code: 'VT',
    value: 'Vermont'
  },
  {
    code: 'WA',
    value: 'Washington'
  },
  {
    code: 'WV',
    value: 'West Virginia'
  },
  {
    code: 'WI',
    value: 'Wisconsin'
  },
  {
    code: 'WY',
    value: 'Wyoming'
  }
];

export const UNITS = [
  {
    name: '美元',
    value: 'USD',
    unit: '$'
  }
];

export const UNITS_MAP: any = {
  USD: '$',
  TWD: '台币',
  USDT: 'USDT',
  USDC: 'USDC',
  $: '美元',
  '￥': '人民币'
};

export const STATUS_MAP: any = {
  REFUND: '退款',
  COMPLETE: '已完成',
  PENDING: '授权中',
  REVERSE: '已撤回',
  REVERSED: '已撤回',
  REVERSING: '撤回中',
  REFUND_PENDING: '退款中'
};

export const MobilePrefix = [
  {
    value: 'US',
    en: 'USA',
    label: '美国(+1)'
  },
  {
    value: 'CN',
    en: 'China',
    label: '中国(+86)'
  },
  {
    value: 'HK',
    en: 'China Hong Kong',
    label: '中国香港(+852)'
  },
  {
    value: 'TW',
    en: 'Taiwan, China',
    label: '中国台湾(+886)'
  },

  {
    value: 'CA',
    en: 'Canada',
    label: '加拿大(+1)'
  },
  {
    value: 'ID',
    en: 'Indonesia',
    label: '印度尼西亚(+62)'
  },
  {
    value: 'SG',
    en: 'Singapore',
    label: '新加坡(+65)'
  },
  {
    value: 'PH',
    en: 'Philippines',
    label: '菲律宾(+63)'
  },
  {
    value: 'MY',
    en: 'Malaysia',
    label: '马来西亚(+60)'
  },
  {
    value: 'TH',
    en: 'Thailand',
    label: '泰国(+66)'
  },
  {
    value: 'KH',
    en: 'Cambodia',
    label: '柬埔寨(+855)'
  },
  {
    value: 'LA',
    en: 'Laos',
    label: '老挝(+856)'
  },

  {
    value: 'MM',
    en: 'Myanmar',
    label: '缅甸(+95)'
  },
  {
    value: 'RU',
    en: 'Russia',
    label: '俄罗斯(+7)'
  },

  {
    value: 'VN',
    en: 'Vietnam',
    label: '越南(+84)'
  }
];

export const LANGUAGE = 'LANGUAGE';

export const DAY = 60;

export const CRISP_ID = '0276d8f2-872d-4d72-b026-7e3b35eab316';

export const BASE_SETTING = {
  email: 'support@IngStart.com',
  phone: '400-9266-900',
  wechat: 'myrrh_y'
};

export const No_Bs_Menu = ['/dashboard', '/setting', '/agent', '/bs/register', '/bs/list', '/bs/shareholder'];

export const US = 'US';
export const HK = 'HK';
export const GB = 'GB';
export const UK = 'GB';
export const SGP = 'SG';

// 公司类型
export const LLC = 'LLC';
export const C_CORP = 'CCORP';
export const S_CORP = 'SCORP';
export const LIMITED = 'PRIVATE_LIMITED';
export const LLP = 'LLP';
export const IP = 'INDIVIDUAL_PROPRIETORSHIP';

export const STEP_1 = 'STEP_1';
export const STEP_2 = 'STEP_2';
export const STEP_3 = 'STEP_3';
export const STEP_4 = 'STEP_4';
export const STEP_5 = 'STEP_5';

export const dataStep = [STEP_1, STEP_2, STEP_3, STEP_4, STEP_5];

export const Languages = [
  {
    value: 'zh',
    label: '简体'
  },
  {
    value: 'en',
    label: 'English'
  }
];

export const AREA = [
  {
    code: HK,
    text: '香港'
  },
  {
    code: UK,
    text: '英国'
  },
  {
    code: US,
    text: '美国'
  },
  {
    code: SGP,
    text: '新加坡'
  }
];

export const AREA_MAP: {
  [n: string]: (typeof AREA)[0];
} = {};

AREA.forEach((x) => {
  AREA_MAP[x.code] = x;
});

export const ALL_STATE = [
  {
    code: 'DE',
    value: 'Delaware',
    text: '特拉华州',
    min: 0.087,
    max: 0.087,
    isRecommand: true
  },
  {
    code: 'WY',
    value: 'Wyoming',
    text: '怀俄明州',
    isRecommand: true,
    min: 0,
    max: 0.065
  },
  {
    code: 'CO',
    value: 'Colorado',
    text: '科罗拉多州',
    min: 0.0463,
    max: 0.0463
  },
  {
    code: 'CA',
    value: 'California',
    text: '加利福尼亚州',
    min: 0.0884,
    max: 0.0884
  },
  {
    code: 'NY',
    value: 'New York',
    text: '纽约州',
    min: 0.065,
    max: 0.065
  },
  {
    code: 'AL',
    value: 'Alabama',
    text: '亚拉巴马州',
    min: 0.065,
    max: 0.1
  },
  {
    code: 'AK',
    value: 'Alaska',
    text: '阿拉斯加州',
    min: 0,
    max: 0
  },
  {
    code: 'AR',
    value: 'Arkansas',
    text: '阿肯色州',
    min: 0.01,
    max: 0.065
  },
  {
    code: 'AZ',
    value: 'Arizona',
    text: '亚利桑那州',
    min: 0.049,
    max: 0.069
  },
  {
    code: 'CT',
    value: 'Connecticut',
    text: '康涅狄格州',
    min: 0.075,
    max: 0.075
  },
  {
    code: 'FL',
    value: 'Florida',
    text: '佛罗里达州',
    min: 0.055,
    max: 0.055
  },
  {
    code: 'GA',
    value: 'Georgia',
    text: '佐治亚州',
    min: 0.06,
    max: 0.06
  },
  {
    code: 'HI',
    value: 'Hawaii',
    text: '夏威夷州',
    min: 0.044,
    max: 0.064
  },
  {
    code: 'IA',
    value: 'Iowa',
    text: '艾奥瓦州',
    min: 0.12,
    max: 0.12
  },
  {
    code: 'ID',
    value: 'Idaho',
    text: '爱达荷州',
    min: 0.06925,
    max: 0.06925
  },
  {
    code: 'IL',
    value: 'Illinois',
    text: '伊利诺伊州',
    min: 0.095,
    max: 0.095
  },
  {
    code: 'IN',
    value: 'Indiana',
    text: '印第安纳州',
    min: 0.0575,
    max: 0.0575
  },
  {
    code: 'KS',
    value: 'Kansas',
    text: '堪萨斯州',
    min: 0.04,
    max: 0.07
  },
  {
    code: 'KY',
    value: 'Kentucky',
    text: '肯塔基州',
    min: 0.05,
    max: 0.05
  },
  {
    code: 'LA',
    value: 'Louisiana',
    text: '路易斯安那州',
    min: 0.04,
    max: 0.08
  },
  {
    code: 'ME',
    value: 'Maine',
    text: '缅因州',
    min: 0.035,
    max: 0.0893
  },
  {
    code: 'MD',
    value: 'Maryland',
    text: '马里兰州',
    min: 0.0825,
    max: 0.0825
  },
  {
    code: 'MA',
    value: 'Massachusetts',
    text: '马萨诸塞州',
    min: 0.08,
    max: 0.08
  },
  {
    code: 'MI',
    value: 'Michigan',
    text: '密歇根州',
    min: 0.06,
    max: 0.06
  },
  {
    code: 'MN',
    value: 'Minnesota',
    text: '明尼苏达州',
    min: 0.098,
    max: 0.098
  },
  {
    code: 'MS',
    value: 'Mississippi',
    text: '密西西比州',
    min: 0.03,
    max: 0.05
  },
  {
    code: 'MO',
    value: 'Missouri',
    text: '密苏里州',
    min: 0.04,
    max: 0.0625
  },
  {
    code: 'MT',
    value: 'Montana',
    text: '蒙大拿州',
    min: 0.0675,
    max: 0.0675
  },
  {
    code: 'NC',
    value: 'North Carolina',
    text: '北卡罗来纳州',
    min: 0.025,
    max: 0.0525
  },
  {
    code: 'ND',
    value: 'North Dakota',
    text: '北达科他州',
    min: 0.014,
    max: 0.0431
  },
  {
    code: 'NE',
    value: 'Nebraska',
    text: '内布拉斯加州',
    min: 0.0558,
    max: 0.0558
  },
  {
    code: 'NH',
    value: 'New Hampshire',
    text: '新罕布什尔州',
    min: 0.077,
    max: 0.077
  },
  {
    code: 'NJ',
    value: 'New Jersey',
    text: '新泽西州',
    min: 0.09,
    max: 0.09
  },
  {
    code: 'NM',
    value: 'New Mexico',
    text: '新墨西哥州',
    min: 0.048,
    max: 0.059
  },
  {
    code: 'NV',
    value: 'Nevada',
    text: '内华达州',
    min: 0,
    max: 0
  },
  {
    code: 'OH',
    value: 'Ohio',
    text: '俄亥俄州',
    min: 0.0026,
    max: 0.04797
  },
  {
    code: 'OK',
    value: 'Oklahoma',
    text: '俄克拉何马州',
    min: 0.06,
    max: 0.06
  },
  {
    code: 'OR',
    value: 'Oregon',
    text: '俄勒冈州',
    min: 0.066,
    max: 0.066
  },
  {
    code: 'PA',
    value: 'Pennsylvania',
    text: '宾夕法尼亚州',
    min: 0.099,
    max: 0.099
  },
  {
    code: 'RI',
    value: 'Rhode Island',
    text: '罗得岛州',
    min: 0.07,
    max: 0.07
  },
  {
    code: 'SD',
    value: 'South Dakota',
    text: '南达科他州',
    min: 0,
    max: 0.09
  },
  {
    code: 'SC',
    value: 'South Carolina',
    text: '南卡罗来纳州',
    min: 0,
    max: 0.05
  },
  {
    code: 'TN',
    value: 'Tennessee',
    text: '田纳西州',
    min: 0.065,
    max: 0.065
  },
  {
    code: 'TX',
    value: 'Texas',
    text: '得克萨斯州',
    min: 0,
    max: 0
  },
  {
    code: 'UT',
    value: 'Utah',
    text: '犹他州',
    min: 0.0495,
    max: 0.0495
  },
  {
    code: 'VA',
    value: 'Virginia',
    text: '弗吉尼亚州',
    min: 0.06,
    max: 0.06
  },
  {
    code: 'VT',
    value: 'Vermont',
    text: '佛蒙特州',
    min: 0.06,
    max: 0.06
  },
  {
    code: 'WA',
    value: 'Washington',
    text: '华盛顿州',
    min: 0.015,
    max: 0.065
  },
  {
    code: 'WV',
    value: 'West Virginia',
    text: '西弗吉尼亚州',
    min: 0.065,
    max: 0.065
  },
  {
    code: 'WI',
    value: 'Wisconsin',
    text: '威斯康星州',
    min: 0.079,
    max: 0.079
  }
];

export const STATE_MAP: {
  [n: string]: (typeof STATE)[0];
} = {};

ALL_STATE.forEach((x) => {
  STATE_MAP[x.code] = x;
});
